// Prices page component
export function WhyPage() {
  return `
<div class="min-h-screen bg-gray-50">
  <div class="hero">
    <div class="hero-content">
      <h1 class="hero-title">Why EPCSpainHomes.com?</h1>
      <p class="hero-subtitle">We connect energy advisors and homeowners</p>
    </div>
  </div>

  <section class="section bg-gray-50">
    <div class="container">
      <div class="max-w-6xl mx-auto prose prose-lg">
        <div class="flex flex-col md:flex-row md:items-start md:space-x-8">

          <!-- Left column -->
          <div class="bg-white p-8 rounded-lg shadow-sm md:w-2/3">
            <h2 class="text-2xl text-blue-900 mb-4">We connect energy advisors and property owners</h2>
            
            <p class="mb-4">
              You need an energy certificate for your home or commercial property in Spain.
              And you want everything to be fast, simple, and professional. You expect friendly service
              at a fair price — and that's exactly why so many people choose EPCSpainHomes.com!
            </p>

            <p class="mb-4">
              At EPCSpainHomes.com, we compare certified energy efficiency advisors across Spain
              and help you find the professional that best fits your situation. We simplify the complicated.
              Our clients rate us an average of 4.9 out of 5 stars, and we are very proud of that —
              it motivates us every day to offer you the best service.
            </p>

            <p class="mb-4">
              You can easily filter by price, delivery time, and rating to find the right energy certificate advisor.
              All advisors registered on our platform are officially accredited by the
              Ministry for the Ecological Transition (MITECO) and work according to the national
              energy certification guidelines (Royal Decree 390/2021).
            </p>

            <p class="mb-4">
              With more than 350 recognized advisors spread throughout Spain, we monitor daily the progress and satisfaction
              of our clients. This way, we know exactly who delivers the fastest, who has the best ratings,
              and who best matches your needs.
            </p>

            <p class="mb-4">
              Thanks to our growing network of reliable advisors, you not only find the best specialist for your
              energy certification, but also guaranteed quality and total peace of mind according to Spanish standards.
            </p>
          </div>

          <!-- Right column -->
          <div class="bg-white p-8 rounded-lg shadow-sm md:w-1/3">
            <img src="/images/team/compare.webp" alt="Compare energy advisors" class="mb-4 w-full h-auto rounded-md object-cover" />
            <p class="mb-4">Start comparing energy efficiency advisors in Spain.</p>
            <p>
              <a href="/cadastro/" data-route="/cadastro/" 
                 class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">
                Compare advisors
              </a>
            </p>
          </div>

        </div>
      </div>
    </div>
  </section>
</div>

  `;
}
